import React, { useCallback } from 'react'
import { Divider } from 'antd'
import { Box } from 'components/Box'
import { Modal } from 'components/CustomModal'
import { Spinner } from 'components/Spinner'
import styled from 'styled-components'
import { useApiClient } from 'utils/api/ApiClient'
import { ClientsApiClient } from 'utils/api/clientsApi'
import { DocumentApiClient } from 'utils/api/documentApi'
import { useFetchOne } from 'utils/api/useFetch'
import { formatLocalDateUTC } from 'utils/date'

const ModalTemplate = styled(Box)`
    width: 90%;
    margin: 32px;
    > div {
        display: flex;
      
        > label {
            font-weight: bold;
            width: 20%;
        }

    .text-blue {
        color: #0e75eb;
    }
`

interface Props {
  id: string
  type: 'client' | 'document'

  hideModal(): void
}

const HistoryDetailsModal: React.FC<Props> = ({ id, type, hideModal }) => {
  const documentApiClient = useApiClient(DocumentApiClient)
  const clientsApiClient = useApiClient(ClientsApiClient)

  const fetchData = useCallback(async () => {
    if (type === 'document') {
      return await documentApiClient.getDocumentHistory(id)
    }
    return await clientsApiClient.getClientHistory(id)
  }, [type, id]) // eslint-disable-line react-hooks/exhaustive-deps
  const { data, isLoading } = useFetchOne(fetchData)

  if (isLoading) {
    return <Spinner />
  }

  return (
    <Modal width={900} visible={true} onClose={() => hideModal()}>
      <ModalTemplate display='flex' flexDirection='column'>
        {data?.history?.map((historyReason, index: number) => (
          <React.Fragment key={index}>
            <div>
              <label>Date</label>
              <span className='text-blue'>
                {formatLocalDateUTC(historyReason?.createdDate, true)}
              </span>
            </div>
            <div>
              <label>Status</label>
              <span className='text-blue'>{historyReason.status.name}</span>
            </div>
            {!historyReason.reason && (
              <div>
                <label>Reason</label>
                <span className='text-blue'>{historyReason.statusReason.name}</span>
              </div>
            )}
            {historyReason?.reason && (
              <div>
                <label>User reason</label>
                <span className='text-blue'>{historyReason?.reason}</span>
              </div>
            )}
            {(data.history || []).length > 1 && <Divider />}
          </React.Fragment>
        )) ?? <label>No history...</label>}
      </ModalTemplate>
    </Modal>
  )
}

export default HistoryDetailsModal
